import * as THREE from 'three';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';

/**
 * Exports an array of Three.js meshes as a GLB binary blob.
 * Uses Three.js's built-in GLTFExporter for guaranteed compatibility
 * with the GLTFModel loader.
 *
 * The meshes are expected to share a neutral-diffuse material constructed via
 * `createNeutralLightingMaterial` (see `create3DMeshes`); the resulting GLB
 * therefore carries a single material entry tuned for downstream lighting
 * visualisation.
 */
export async function exportToGLB(meshes: THREE.Mesh[]): Promise<Blob> {
  const scene = new THREE.Scene();
  scene.name = 'DXF_Scene';

  meshes.forEach((mesh) => {
    // Clone to avoid modifying originals
    const clone = mesh.clone();
    scene.add(clone);
  });

  const exporter = new GLTFExporter();
  const glb = await exporter.parseAsync(scene, { binary: true });

  return new Blob([glb as ArrayBuffer], { type: 'model/gltf-binary' });
}
